/* eslint-disable */
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import CardTitle from "@saleor/components/CardTitle";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

// import { orderSendErp } from "@saleor/orders/queries";

import { ORDERSENDERP } from "@saleor/orders/queries";
import { OrderDetails_order } from "../../types/OrderDetails";

export interface OrderInvoiceListProps {
  sendErp: boolean;
  order: OrderDetails_order;
  // onInvoiceGenerate: () => void;
}
import { useLazyQuery } from "@apollo/react-hooks";
import useNotifier from "@saleor/hooks/useNotifier";

const OrderSendErp: React.FC<OrderInvoiceListProps> = props => {
  const { sendErp, order } = props;
  const [sendErpQuery, setSendErpQuery] = React.useState<any>(sendErp);
  const notify = useNotifier();

  const [getOrderSendErp] = useLazyQuery(ORDERSENDERP, {
    fetchPolicy: "no-cache",
    onCompleted: data => {
      if (data?.sendErp?.success) {
        setSendErpQuery(data?.sendErp?.success);
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "The order was successfully imported to erp.",
            description: "snackbar text"
          })
        });
      } else {
        notify({
          status: "error",
          text: intl.formatMessage({
            defaultMessage: "Failed to import erp.",
            description: "snackbar text"
          })
        });
      }
    }
  });

  // const [sendErps, setsendErps] = React.useState()
  const intl = useIntl();

  function onSendErp() {
    getOrderSendErp({ variables: { orderid: Number(order.number) } });
  }
  React.useEffect(() => {
    setSendErpQuery(sendErp);
  }, [sendErp]);

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "SendErp",
          description: "section header"
        })}
        toolbar={
          <Button color="primary" onClick={onSendErp}>
            <FormattedMessage defaultMessage="send" description="send button" />
          </Button>
        }
      />
      <CardContent>
        <Typography color="textSecondary">
          {sendErpQuery !== undefined && `${sendErpQuery ? "Yes" : "No"}`}
        </Typography>
      </CardContent>
    </Card>
  );
};

OrderSendErp.displayName = "OrderSendErp";
export default OrderSendErp;
